module.exports = __webpack_public_path__ + "img/check.8075fd26.svg";